import React, { Component } from 'react'
import classnames from 'classnames'

import { withSettings } from './withSettings'
import Form from './Form'
import Toggle from './Form/toggle'
import PremiumLabel from './Form/PremiumLabel'
import SignUpFormSetting from './SignUpFormSetting'
import { isPremium } from '../../../../utils/plans'

@withSettings
export default class RegistrationSettings extends Component {

  handleData = data => this.props.setSettingsAt('registration', data)

  render() {
    const reg = this.props.getSettingsAt('registration')
    const { websites: { current:website } } = this.props

    return (
      <div className="container padded settings">
        <Form onData={this.handleData}>
          <div className="panel padded">
            <h2 className="title">Registration Settings</h2>
            <div className="form-section">
              <p className="muted">
                You can restrict certain information from leads that they only see
                after registering or signing in.
              </p>
              <strong>Recommendation:</strong>
              <p>
                We don’t recommend putting a restriction on listings.
                With the current competition for online consumer
                attention, there’s a good chance that a high proportion of
                leads will bounce off your site. You must establish
                enough value before demanding a registration. We recommend the
                Search Results and Premium Listing Detail Page Content locks.
              </p>
            </div>
          </div>

          <div className="panel padded">
            <div className="form-section">
              <label>Listing Detail Page Views</label>
              <p className="muted">
                The maximum number of listing detail pages a lead can view until they
                are prompted to register or sign in.
              </p>
              <Toggle
                on={reg.ldp_lock}
                name="ldp_lock">
                {locked => (
                  <strong>
                    Listing Detail Page View Lock ({locked ? 'On' : 'Off'})
                  </strong>
                )}
              </Toggle>

              <div style={{display: 'flex', margin: 20}}>
                <input
                  type="radio"
                  id="ldp_lock_type_soft"
                  defaultChecked={reg.ldp_lock_type === 'soft'}
                  name="ldp_lock_type"
                  style={{flexBasis: 18, display: 'inline', width: 'auto', marginLeft: 50, marginRight: 25}}
                  value="soft" />
                <div>
                  <label htmlFor="ldp_lock_type_soft">
                    <strong>Registration Prompt (Soft)</strong>
                  </label>
                  <p className="muted">
                    Displays a prompt for the lead to register or sign in that can be skipped.
                  </p>
                  <select name="ldp_lock_soft_recurring" defaultValue={reg.ldp_lock_soft_recurring}>
                    <option value="every">Display Prompt Every</option>
                    <option value="once">Display Prompt Once When</option>
                  </select>
                  <input
                    type="number"
                    name="ldp_lock_soft_frequency"
                    style={{display: 'inline', width: 50, margin: '0 10px', paddingRight: 0}}
                    defaultValue={reg.ldp_lock_soft_frequency} />
                  listing detail pages viewed.
                </div>
              </div>

              <div style={{display: 'flex', margin: 20}}>
                <input
                  type="radio"
                  id="ldp_lock_type_hard"
                  defaultChecked={reg.ldp_lock_type === 'hard'}
                  name="ldp_lock_type"
                  style={{flexBasis: 18, display: 'inline', width: 'auto', marginLeft: 50, marginRight: 25}}
                  value="hard" />
                <div>
                  <label htmlFor="ldp_lock_type_hard">
                    <strong>Registration Prompt (Hard)</strong>
                  </label>
                  <p className="muted">
                    Displays a prompt after a preset number of listing detail page views.
                    The lead cannot see any other listing detail pages until they register or
                    sign in.
                  </p>
                  Require registration for leads when
                  <input
                    type="number"
                    name="ldp_lock_hard_frequency"
                    style={{display: 'inline', width: 50, margin: '0 10px', paddingRight: 0}}
                    defaultValue={reg.ldp_lock_hard_frequency} />
                  listing detail pages viewed.
                </div>
              </div>
            </div>

            <div className={classnames('form-section', { disabled: !isPremium(website.plan) })}>
              <label>Search Results</label>
              <PremiumLabel website={website}/>
              <p className="muted">
                Set the maximum number of search results a lead can see before they have to register.
              </p>
              <Toggle
                disabled={!isPremium(website.plan)}
                on={reg.search_results_lock}
                name="search_results_lock">
                {locked => (
                  <strong>
                    Search Results Lock ({locked ? 'On' : 'Off'})
                  </strong>
                )}
              </Toggle>
              <div style={{margin: 20, marginLeft: 70}}>
                Require registration for leads to view over
                <input
                  type="number"
                  name="search_results_lock_frequency"
                  style={{display: 'inline', width: 50, margin: '0 10px', paddingRight: 0}}
                  defaultValue={reg.search_results_lock_frequency}
                  disabled={!isPremium(website.plan)} />
                search results pages for any search.
              </div>
            </div>

            <div className={classnames('form-section', { disabled: !isPremium(website.plan) })}>
              <label>Premium Listing Content</label>
              <PremiumLabel website={website}/>
              <p className="muted">
                Require leads to register to see premium listing content (community and listing stats).
              </p>
              <p className="muted">
                  Demographics data is currently not available in Canada.
              </p>
              <Toggle
                disabled={!isPremium(website.plan)}
                on={reg.premium_listing_content_lock}
                name="premium_listing_content_lock">
                {locked => (
                  <strong>
                    Premium Listing Content Lock  ({locked ? 'On' : 'Off'})
                  </strong>
                )}
              </Toggle>
            </div>
          </div>

          <SignUpFormSetting reg={reg} website={website} />

          <button type="submit" className="big shadowed">Save Changes</button>
        </Form>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/settings/Registration.js